import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { fontSize, wh } from '../../../mixins';

const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

const ReviewItem = styled.div`
  background: #FFFFFF;
  box-shadow: 4px 6px 20px rgba(0,0,0,.12);
  border-radius: 12px;
  padding: 12px 16px;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const ReviewHead = styled.div`
  height: 15px;
  display: flex;
  flex-direction: row${isArabic ? '-reverse' : ''};
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
`;

const ReviewBody = styled.div`
  display: flex;
  flex-direction: row${isArabic ? '-reverse' : ''};
  align-items: center;
  margin-bottom: 8px;
`;

const ReviewerPhoto = styled.img`
  ${wh('30px')};
  margin-right: 8px;
  margin-left: 8px;
  margin-${textAlign}: 0;
`;

const ReviewerName = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #323232;
`;

const AppIcon = styled.div`
  ${wh('15px')};
  background-image: url('../assets/app-icon.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 7px;
  margin-left: 7px;
  margin-${textAlign}: 0;
`;

const Rate = styled.div`
  ${wh('53px', '10px')};
  background-image: url('../assets/stars.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
`;

const MarketIcon = styled.div`
  flex-grow: 1;
  height: 100%;
  background-image: url('../assets/${({market}) => market}-icon.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: ${isArabic ? 'left' : 'right'} center;
`;

const ReviewText = styled.div`
  font-weight: 400;
  ${fontSize(14)};
  line-height: 17px;
  letter-spacing: -0.24px;
  text-align: ${textAlign};
`;

const ReviewsBlock = () => {
  const { t } = useTranslation();

  const REVIEWS = useMemo(() => {
    return [
      {
        market: 'apple',
        reviewer: 'John Eydman',
        reviewerSource: '../assets/reviewer1.png',
        text: t('review_1'),
      },
      {
        market: 'apple',
        reviewer: 'Chris Topper',
        reviewerSource: '../assets/reviewer2.png',
        text: t('review_2'),
      },
      {
        market: 'android',
        reviewer: 'Jane Stevenson',
        reviewerSource: '../assets/reviewer3.png',
        text: t('review_3'),
      },
    ];
  }, [t]);

  const renderReview = (rev, index) => {
    return (
      <ReviewItem key={index}>
        <ReviewHead>
          <AppIcon />
          <Rate />
          <MarketIcon market={rev.market} />
        </ReviewHead>
        <ReviewBody>
          <ReviewerPhoto src={rev.reviewerSource} alt={rev.reviewer}/>
          <ReviewerName>{rev.reviewer}</ReviewerName>
        </ReviewBody>
        <ReviewText>{rev.text}</ReviewText>
      </ReviewItem>
    )
  };

  return REVIEWS.map(renderReview)
};

export default ReviewsBlock